export const artistsFilters = [
  { label: 'by_favorited_count', value: '-favorited_count' },
  { label: 'by_name', value: 'artist__name' },
  { label: 'by_time', value: 'start_datetime' }
]

export const stagesFilters = [
  { label: 'by_title', value: 'name' },
  { label: 'by_time', value: 'start_datetime' }
]
